import { LegalLayout, Section, List } from "./LegalLayout";
import { COMPANY, displayLegalName, formatAddress } from "@/config/company";

/**
 * Note legali: le informazioni che l'art. 7 del D.Lgs 70/2003 impone di rendere
 * "facilmente, direttamente e permanentemente accessibili" a chi usa un servizio
 * della società dell'informazione.
 */
export default function LegalNoticePage() {
  return (
    <LegalLayout
      title="Note legali"
      subtitle="Informazioni sul gestore del sito, ai sensi dell'art. 7 del D.Lgs 70/2003."
    >
      <Section n={1} title="Titolare del sito">
        <div className="rounded-2xl border border-black/10 bg-white p-6 space-y-1.5 text-[15px]">
          <div>
            <strong>{displayLegalName()}</strong>
            {COMPANY.legalForm ? ` — ${COMPANY.legalForm.toLowerCase()}` : ""}
          </div>
          {formatAddress() && <div>Sede: {formatAddress()}</div>}
          {COMPANY.vat && <div>Partita IVA: {COMPANY.vat}</div>}
          {COMPANY.taxCode && <div>Codice fiscale: {COMPANY.taxCode}</div>}
          {COMPANY.rea && <div>Numero REA: {COMPANY.rea}</div>}
          {COMPANY.shareCapital && <div>Capitale sociale: {COMPANY.shareCapital}</div>}
          <div className="pt-2">
            Email:{" "}
            <a href={`mailto:${COMPANY.email}`} className="underline underline-offset-4">
              {COMPANY.email}
            </a>
          </div>
          {COMPANY.pec && <div>PEC: {COMPANY.pec}</div>}
          {COMPANY.phone && (
            <div>
              Telefono:{" "}
              <a
                href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
                className="underline underline-offset-4"
              >
                {COMPANY.phone}
              </a>
            </div>
          )}
        </div>
        <p>
          {COMPANY.brand} è un software di proprietà di{" "}
          <a
            href={COMPANY.ownerUrl}
            target="_blank"
            rel="noreferrer noopener"
            className="underline underline-offset-4"
          >
            {COMPANY.owner}
          </a>
          . Questo sito ne cura la presentazione e la commercializzazione.
        </p>
      </Section>

      <Section n={2} title="Proprietà intellettuale">
        <p>
          Il marchio {COMPANY.brand}, il logo, i testi, la grafica, il codice sorgente e gli
          altri contenuti del sito sono di proprietà del titolare o utilizzati su licenza.
          Non è consentita la riproduzione, anche parziale, senza autorizzazione scritta,
          salvo il normale uso di consultazione e la citazione con indicazione della fonte.
        </p>
        <p>
          Alcune immagini di ambientazione provengono da banche dati fotografiche
          utilizzate secondo le rispettive licenze d'uso e hanno finalità illustrativa: non
          raffigurano clienti o locali reali.
        </p>
      </Section>

      <Section n={3} title="Contenuti illustrativi">
        <p>
          Le schermate e le anteprime del prodotto mostrate sul sito hanno scopo
          dimostrativo. Dati, nomi e importi visualizzati sono di esempio e non
          corrispondono a persone o attività reali.
        </p>
      </Section>

      <Section n={4} title="Collegamenti a siti terzi">
        <p>
          Il sito può contenere collegamenti a risorse esterne. Il titolare non esercita
          alcun controllo su tali risorse e non risponde dei loro contenuti né del
          trattamento dei dati che vi avviene.
        </p>
      </Section>

      <Section n={5} title="Risoluzione delle controversie">
        <p>Il sito e il servizio sono regolati dalla legge italiana.</p>
        <List
          items={[
            "Per i rapporti con imprese e professionisti si rinvia ai Termini di servizio.",
            "Le segnalazioni relative a contenuti del sito possono essere inviate all'indirizzo email indicato al punto 1: rispondiamo entro 30 giorni.",
          ]}
        />
      </Section>
    </LegalLayout>
  );
}
